import React, { useState, useEffect, useRef } from "react";
import { axiosReq } from "../../../commons/axiosReq";

const MainAdminMacroeconomicIndicators = ({data,time}) => {
     const [allValues, setAllValues] = useState({
            Title: data ? data.title : '',
            Value: data ? data.value : '',
            Date: data ? data.date : '',
  
    
        });
        const changeHandler = e => {
            if (e.target) {
             
                // setAllValuesError({ ...allValuesError, [""]: false })
    
    
                setAllValues({ ...allValues, [e.target.name]: e.target.value })
            }
        }
         const editIndex = async () => {        
                // setSnipper(true)
               
              
                 
                    const dataUser = await axiosReq("Admins/UpdateIndex", "put", {
                        IndexId: data?.indexId,
                        Title: allValues?.Title,
                        Value: allValues?.Value,
                        Date: allValues?.Date,
                     
        
                    });
                    console.log(dataUser)
                    if (dataUser?.status == 200 || dataUser?.status == 204 || dataUser?.status == 201) {
        
                        //   navigate("/newRequestStep2/" + dataUser?.data?.requestId)
                        alert("موفقیت آمیز");
                    }
                    else {
                        alert("خطا");

                    }
                
               
            }
    return(
        <div className="flex justify-start items-end">
            {time === true ?
            <>
            <div className="w-[23%] ml-[1%]">
            <p className="text-[15px] font-IRANYekanExtra text-mainColor2 mb-[10px]">عنوان شاخص</p>
            <input    value={allValues?.Title}
            name="Title"   
                 onChange={changeHandler}
 className="h-[35px]  w-full focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray" type="text" placeholder="عنوان شاخص" />
            </div>
            <div className="w-[23%] ml-[1%]">
            <p className="text-[15px] font-IRANYekanExtra text-mainColor2 mb-[10px]">مقدار</p>
            <input       value={allValues?.Value}       
               name="Value"                  
                   onChange={changeHandler}
className="h-[35px]  w-full focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray" type="text" placeholder="مقدار" />
            </div>
            <div className="w-[22%] ml-[1%]">
            <p className="text-[15px] font-IRANYekanExtra text-mainColor2 mb-[10px]">تاریخ</p>
            <input       value={allValues?.Date}       
               name="Date"                  
                   onChange={changeHandler}
className="h-[35px]  w-full focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray" type="text" placeholder="تاریخ" />
            </div>
            </>
            :
            <>
            <div className="w-[27%] ml-[1%]">
            <p className="text-[15px] font-IRANYekanExtra text-mainColor2 mb-[10px]">عنوان شاخص</p>
            <input    value={allValues?.Title}
            name="Title"   
                 onChange={changeHandler}
 className="h-[35px]  w-full focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray" type="text" placeholder="عنوان شاخص" />
            </div>
            <div className="w-[42%] ml-[1%]">
            <p className="text-[15px] font-IRANYekanExtra text-mainColor2 mb-[10px]">مقدار</p>
            <input       value={allValues?.Value}       
               name="Value"                  
                   onChange={changeHandler}
className="h-[35px]  w-full focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray" type="text" placeholder="مقدار" />
            </div>
            </> 
            }
           
            <div className="w-[8%] ">
            <button onClick={()=>editIndex()} className="w-full h-[35px] bg-Orange2 shadow-norm-shadow rounded-[10px] flex justify-center items-center ">
                <p className="font-IRANYekanBold text-[15px] text-white">ثبت</p>
            </button>
            </div>
        </div>
    )
}

export default MainAdminMacroeconomicIndicators;